<!--
 * @Author: ningbo.kang
 * @Date: 2019-12-23 18:18:11
 * @LastEditors: error: git config user.email & please set dead value or install git
 * @LastEditTime: 2023-05-04 18:25:40
 * @FilePath: /bpm-form/src/components/wgForm/widget-items/wg-select.vue
 * @Description: 描述
 -->

<template>
  <div :title="text"
    widget-type="treeSelect">
    <a-tree-select v-model="text"
      :size="size"
      :data-model="fieldName"
      :disabled="disabled"
      :placeholder="disabled ? '' : placeholder"
      :class="options.customClass"
      :allowClear="options.clearable"
      :searchPlaceholder="t('wg.treeSelectPlaceholder')"
      :treeCheckable="options.multiple"
      :showCheckedStrategy="options.showCheckedStrategy"
      :treeData="treeData"
      :showSearch="true"
      treeNodeFilterProp="title"
      @change="handleChange">
    </a-tree-select>
  </div>
</template>
<script>
import debounce from 'lodash/debounce';
import baseMixin from '../../lib/baseMixin';

// 选择模式，antd默认SHOW_ALL
const checkedStrategy = {
  SHOW_ALL: 'SHOW_ALL',
  SHOW_PARENT: 'SHOW_PARENT',
  SHOW_CHILD: 'SHOW_CHILD',
};
export default {
  mixins: [baseMixin],
  data() {
    return {
      options: {
        defaultValue: '',
        multiple: false,
        disabled: false,
        clearable: false,
        placeholder: '',
        required: false,
        showLabel: false,
        width: '',
        options: [],
        remote: false,
        remoteType: 'func',
        remoteOption: '',
        filterable: false,
        remoteOptions: [],
        children: 'children',
        props: {
          value: 'value',
          label: 'label',
        },
        remoteFunc: '',
        customClass: '',
        labelWidth: 100,
        isLabelWidth: false,
        hidden: false,
        dataBind: true,
        // 树状选择模式
        showCheckedStrategy: checkedStrategy.SHOW_PARENT,
      },
      fetching: false,
      selectList: [],
      valueList: [],
      hasChanged: false,
    };
  },
  computed: {
    treeData() {
      /**
       * selectList 全部有效节点数据，用户可以选择
       * valueList 包含值对应的节点数据，但这部分节点在selectList 中不存在
       * 目的: 解决 选项 selectList中没有选项值，无法匹配，完善功能
       */
      return this.setParentName([...this.selectList, ...this.valueList]);
    },
  },
  mounted() {
    // if (this.options.filterable) {
    this.fetchOptions = debounce(this.fetchOptions, 800);
    // } else {
    //   this.initOptions();
    // }
    this.initOptions();
  },
  methods: {
    initVal(val) {
      // 如果是自动触发的，做一次数据匹配
      // TODO: 等待接口完善后，开启，多一次查询
      if (!this.hasChanged) {
        if (val) {
          // this.initOptions({ key: val });
        }
      }
      // 数据库返回的是字符串，如果是多选，则转化为数组给组件使用
      // 多选转为数组
      if (this.widget.options.multiple) {
        if (val) {
          this.text = val.split(',');
        } else {
          this.text = [];
        }
      } else if (val) {
        this.text = val;
      } else {
        this.text = undefined;
      }
    },
    handleChange(val, lable, extra) {
      this.hasChanged = true;
      // 将数组转为字符串，数据库服务器存储字符串，因此需要将数组转为字符串
      let newVal;

      let selectedItems = [];
      if (this.options.multiple) {
        newVal = val.join();
        if (newVal) {
          selectedItems = extra.allCheckedNodes.map(selectItem => selectItem.node.data.props.dataRef);
        }
      } else {
        newVal = val || this.defaultValue;
        if (newVal) {
          selectedItems = [extra.triggerNode.dataRef];
        }
      }
      if (!this.isNested) {
        const { rowIndex, fieldName: field } = this;
        const value = {
          type: 'treeSelect',
          rowIndex,
          field,
          value: newVal,
          selectedItems,
        };
        this.dispatch('wgForm', `on-${this.fieldName}-change`, value);
      }
      // 将数据抛给上一层，主要是被子表格服务
      this.$emit('change', newVal, { selectedItems });
    },
    initOptions(otherArgs) {
      const {
        remote, remoteType, remoteOption, remoteFunc,
      } = this.options;
      const { func, args } = this.separateFunc(remoteFunc);
      if (remote && remoteType === 'func' && this.remote[func]) {
        this.remote[func](
          (data) => {
            if (otherArgs) {
              this.valueList = [...data];
            } else {
              this.selectList = [...data];
            }
          },
          { args, otherArgs },
        );
      } else if (remote && remoteType === 'option' && this.dynamic[remoteOption]) {
        this.selectList = this.dynamic[remoteOption];
      } else {
        this.selectList = this.options.options;
      }
    },

    fetchOptions() {},
    setParentName(list, parent) {
      // 整理数据，给子节点增加父层信息
      return list.map((item) => {
        if (item.children) {
          const setNameObj = {
            ...item,
            parentName: (parent ? `${parent.parentName}/` : '') + item.title,
            parentEnName: (parent ? `${parent.parentEnName}/` : '') + item.enTitle,
          };
          return {
            ...setNameObj,
            children: this.setParentName(item.children, setNameObj),
          };
        }
        return {
          ...item,
          parentName: (parent ? `${parent.parentName}/` : '') + item.title,
          parentEnName: (parent ? `${parent.parentEnName}/` : '') + item.enTitle,
        };
      });
    },
  },
};
</script>
